import {
  Badge,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
  Typography,
} from '@growdash/design-system/atoms';
import { LoadingWithTextLoop } from '@growdash/design-system/molecules/index.js';
import useCurrency from '@growdash/growintel/hooks/useCurrency';
import { useGrowintel } from '@growdash/growintel/hooks/useGrowIntel';
import useTabState from '@growdash/growintel/hooks/useTabState';
import { executeFacadeRequest } from '@growdash/growintel/lib/aisha';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
// @ts-ignore

type Props = {};

export default function MenuGenerateView({}: Props) {
  const { lib } = useGrowintel();
  const { filters } = useTabState('ai');
  const { aishaService } = lib;
  // const userBrands = useBrands();
  const [isError, setIsError] = useState(false);
  const brand = filters?.menuGenerateBrand;
  const { data, isFetching } = useQuery({
    queryKey: ['menu-generate', brand?.id],
    queryFn: async (): Promise<any | undefined> => {
      if (!filters.menuGenerateBrand || !aishaService) return null;

      try {
        const response: any = await executeFacadeRequest(
          'int-men-kebabs',
          aishaService,
          { brand_name: brand?.brand_name },
        );
        setIsError(false);
        return response.result;
      } catch (error) {
        setIsError(true);
        console.error('error while fetching menu generate', error);
        throw error;
      }
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  });

  const currency = useCurrency();

  if (isError && !isFetching) {
    return (
      <Card className="py-12 text-center text-muted-foreground">
        <p className="text-red-400">
          An error occurred while generating the menu. Please try again.
        </p>
      </Card>
    );
  }

  if (!data && !isFetching) {
    return (
      <Card className="py-12 text-center text-muted-foreground">
        <p>Select a brand to see suggested menu items</p>
      </Card>
    );
  }

  return (
    <>
      {isFetching && (
        <div className="z-50">
          <LoadingWithTextLoop
            loopTexts={['Generating menu.', ' This might take a while.']}
          />
        </div>
      )}

      {!isFetching && (
        <div className="space-y-6 animate-fade-in">
          <div className="">
            <Typography className="text-normal text-muted-foreground mt-2">
              Here are the suggested menu items for {brand?.brand_name}
            </Typography>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {data?.menu?.map((item: any) => (
              <Card className="shadow-inner col-span-1 pb-0 flex flex-col">
                <CardHeader className="flex ">
                  <div className="flex w-full justify-between">
                    <CardTitle>{item['item-name']}</CardTitle>
                    <Badge variant="secondary">{item['section-name']}</Badge>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="mt-2">
                    <Typography className="text-secondary text-sm">
                      {item['item-description']}
                    </Typography>
                  </div>
                </CardContent>
                <CardFooter className="text-xl font-bold flex justify-end mt-auto">
                  {item['suggested-price']} {currency}
                </CardFooter>
              </Card>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
